module.exports = {
	"id": "SK",
	"name": "Slovakia (Slovak Republic)",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.030696,
			"12": 0.015348,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.03837,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.015348,
			"27": 0.007674,
			"28": null,
			"29": 0.015348,
			"30": null,
			"31": 0.030696,
			"32": 0.015348,
			"33": 0.023022,
			"34": 0.046044,
			"35": 0.023022,
			"36": 0.260916,
			"37": 0.030696,
			"38": 0.03837,
			"39": 0.053718,
			"40": 0.023022,
			"41": 0.023022,
			"42": 0.023022,
			"43": 0.11511,
			"44": 0.053718,
			"45": 0.023022,
			"46": 0.03837,
			"47": 0.069066,
			"48": 0.107436,
			"49": 2.893098,
			"50": 0.138132,
			"51": 0.46044,
			"52": 0.414396,
			"53": 29.636988,
			"54": 7.94259,
			"55": 0.122784,
			"56": 0.023022,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.030696,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.007674,
			"11": null,
			"12": 0.023022,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.007674,
			"20": 0.007674,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.023022,
			"25": null,
			"26": 0.015348,
			"27": 0.015348,
			"28": 0.023022,
			"29": 0.053718,
			"30": 0.015348,
			"31": 0.015348,
			"32": 0.007674,
			"33": 0.07674,
			"34": 0.030696,
			"35": 0.015348,
			"36": 0.061392,
			"37": 1.105056,
			"38": 0.107436,
			"39": 0.061392,
			"40": 0.03837,
			"41": 0.053718,
			"42": 0.107436,
			"43": 0.199524,
			"44": 0.092088,
			"45": 0.368352,
			"46": 0.107436,
			"47": 0.859488,
			"48": 0.621594,
			"49": 14.135508,
			"50": 0.03837,
			"51": 0.007674,
			"52": 0.015348,
			"3.5": 0.015348,
			"3.6": 0.03837
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.023022,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.015348,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.015348,
			"27": null,
			"28": 0.007674,
			"29": null,
			"30": 0.023022,
			"31": 0.007674,
			"32": null,
			"33": 0.007674,
			"34": 0.015348,
			"35": 0.023022,
			"36": 0.207198,
			"37": 0.099762,
			"38": 0.053718,
			"39": 0.03837,
			"40": 2.41731,
			"41": 0.437418,
			"42": 0.007674,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.030696,
			"11.1": null,
			"11.5": 0.015348,
			"11.6": 0.023022,
			"12.1": 0.406722
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.023022,
			"6": null,
			"7": 0.023022,
			"8": 0.099762,
			"9": 0.138132,
			"10": 1.435038,
			"3.1": null,
			"3.2": null,
			"5.1": 0.061392,
			"6.1": 0.030696,
			"7.1": null,
			"9.1": 0.621594
		},
		"ios_saf": {
			"8": 0,
			"10": 2.37496022565,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0640024299542,
			"8.1-8.4": 0.118241777373,
			"9.0-9.2": 0.0564089213156,
			"9.3": 0.860597645712
		},
		"android": {
			"3": 0,
			"4": 0.0350613359173,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00438266698966,
			"4.1": 0.126471247416,
			"4.2-4.3": 0.31617811854,
			"4.4": 0.725018339147,
			"4.4.3-4.4.4": 0.73127929199
		},
		"ie": {
			"6": 0.00771113225806,
			"7": 0.00771113225806,
			"8": 0.246756232258,
			"9": 0.161933777419,
			"10": 0.177356041935,
			"11": 4.17943368387,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0436494925249,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00121248590347
		},
		"edge": {
			"12": 0.053718,
			"13": 0.406722,
			"14": 1.603866
		},
		"ie_mob": {
			"10": 0.097734,
			"11": 0.397917
		},
		"bb": {
			"7": 0.02036125,
			"10": null
		},
		"samsung": {
			"0": 1.635881
		},
		"and_uc": {
			"0": 0.144274
		},
		"op_mini": {
			"0": 0.588082021572
		},
		"and_chr": {
			"0": 15.593899
		},
		"and_ff": {
			"0": 0.030251
		}
	},
	"total": 98.27320525
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SK.json
 ** module id = 645
 ** module chunks = 0
 **/